/*setTimeout(function(){
  $("ul.product-single-slider li .product-single__media").addClass("in-slow"); 
}, 1000);*/

theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();

  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
                                                 }
                                                 };
                                                 formOverride = function(){
                             $formContainer.on('submit', function(evt){
        evt.preventDefault();
        wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
      });
    };
    itemAddedCallback = function(product){
      wc_theme_source.lib.get_cart(cartUpdateCallback);
    };
    itemErrorCallback = function(XMLHttpRequest, textStatus){
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      $addToCart.removeClass('is-adding is-added');
      if(!!data.message){
        if(data.status == 422){
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
      }
    };
    cartUpdateCallback = function(cart){
      updateCountPrice(cart);
      buildCart(cart);
    };
    buildCart = function(cart){
      $cartContainer.empty();
      if(cart.item_count === 0){
        $cartContainer.append('<div class="wf-wrap"><h5 class="empty_cart_slide_cls">' + "Your cart is currently empty." + '</h5></div>');
        cartCallback(cart);
        return;
      }
      var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
      $.each(cart.items, function(index, cartItem){
        if(cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else{
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        if(cartItem.properties !== null){
          $.each(cartItem.properties, function(key, value){
            if(key.charAt(0) === '_' || !value){
              delete cartItem.properties[key];
            }
          });
        }
        item = {
          key: cartItem.key,
          line: index + 1,
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, shop_currency),
          final_price: Shopify.formatMoney(cartItem.final_line_price, shop_currency),
          discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
          discounts: cartItem.discounts,
          discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
          vendor: cartItem.vendor
        };
        items.push(item);
      });
      data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
      };
      $cartContainer.append(template(data));
      cartCallback(cart);
    };

    cartCallback = function(cart){
      $body.trigger('ajaxCart.afterCartLoad', cart);
      wc_theme_source.lib.on_cart_update(cart);
      if(window.Shopify && Shopify.StorefrontExpressButtons){
        Shopify.StorefrontExpressButtons.initialize();
      }
    };

    adjustCart = function(){
      $body.on('click', '.ajaxcart__qty-adjust', function(){
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
        var qty = validateQty(qty);
        if($el.hasClass('ajaxcart__qty--plus')){
          qty += 1;
        } else{
          qty -= 1;
          if(qty <= 0) qty = 0;
        }
        if(line){
          updateQuantity(line, qty);
        } else{
          $qtySelector.val(qty);
        }    
      });

      $body.on('click', '.cart_remove_item', function(){
        var line = $(this).attr('data-line');
        wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
      });
      $body.on('change', '.ajaxcart__qty-num', function(){
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), qty = parseInt($el.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        if(line){
          updateQuantity(line, qty);
        }
      });
      $body.on('submit', 'form.ajaxcart', function(evt){
        if(isUpdating){
          evt.preventDefault();
        }
      });
      $body.on('focus', '.ajaxcart__qty-adjust', function(){
        var $el = $(this);
        setTimeout(function(){
          $el.select();
        }, 50);
      });
      function updateQuantity(line, qty){
        isUpdating = true;
        var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
        if(qty === 0){
          $row.parent().addClass('is-removed');
        }
        setTimeout(function(){
          wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
        }, 250);
      }
    };
    adjustCartCallback = function(cart){
      updateCountPrice(cart);
      setTimeout(function(){
        wc_theme_source.lib.get_cart(buildCart);
        isUpdating = false;
      }, 150)
    };
    validateQty = function(qty){
      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
        qty = 1;
      }
      return qty;
    };
    module = {
      init: init,
      load: loadCart
    };
    return module;
  }(ajaxCart || {}, jQuery));



  var shop_currency_default = $('#shop_currency_val').text();
  function myCartSection() {
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight();
    $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
  }
  jQuery(window).resize(function(){
    myCartSection();
  });

  var shop_currency = shop_currency_default;

  var wc_theme_source = {
    lib:{
      ajax_error: function(error, message, this_click){      
        var data = eval('('+error.responseText+')');
        if(!!data.message){        
          if(this_click == 'grid_click'){          
            var itrmCount = data.description.split(' ')[1];
            jQuery('.cartCount_item').text(itrmCount);
            jQuery('#cart_error_message').find('h5').text(data.description);         

          }else{
            jQuery('.responseJSON_Error').find('h5').text(data.description);
            jQuery('.responseJSON_Error').show();
          }
        }
      },
      on_cart_update: function(item){
        setTimeout(function(){
          jQuery.getJSON('/cart.js', function(cart) {
            $('.cart_qty_cls').html(cart.item_count);
            if(cart.item_count > 0){
              var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
              if($('.items_carts span').hasClass('money')){
                $('.items_carts span').remove();
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              } else{
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              }
            } else{
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>$0.00</span>");
            }
            setTimeout(function(){            
              myCartSection();
            },1000);
            
            
            var cartQtyCount = cart.item_count;
            
            if(cartQtyCount != '' || cartQtyCount != null || cartQtyCount != undefined || cartQtyCount > 0){
              $('.thi-cart .cart-count').text(cartQtyCount);
            }
            
          });
          
        },100);
      },
      on_item_added: function(item){

        ajaxCart.load();
      },
      on_product: function(e){
        alert("Received everything we ever wanted to know about " + e.title);
      },
      addtocart_product: function(id, qty, callback,this_click){
        var qty = qty || 1;
        var ajax = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + qty + "&id=" + id,
          dataType: "json",
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){           
              $('body').addClass('CartOpen');            
            },500);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
          }
        };
        jQuery.ajax(ajax);
      },
      get_product: function(handle, callback){
        jQuery.getJSON("/products/" + handle + ".js", function(product, n){
          wc_theme_source.lib.on_product(product);
        });
      },
      get_cart: function(callback){
        jQuery.getJSON("/cart.js", function(cart, textstatus){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        });
      },
      addtocart_form: function(form_id, callback, errorCallback, this_click){
        var ajax = {
          type: 'POST',
          url: '/cart/add.js',
          data: jQuery('#' + form_id).serialize(),
          dataType: 'json',
          beforeSend: function(){
            jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, form_id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){


              $('body').addClass('CartOpen');

            },500);
          },
          error: function(XMLHttpRequest, textStatus){
            if((typeof errorCallback) === 'function'){
              errorCallback(XMLHttpRequest, textStatus);
            } else{
              wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
            }
          }
        };
        jQuery.ajax(ajax);
      },
      cart_change_item: function(line, qty, callback){
        var ajax = {
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + qty + '&line=' + line,
          dataType: 'json',
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_remove_item: function(line, callback){
        var ajax = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&line=" + line,
          dataType: "json",
          beforeSend: function(){
            jQuery('.cart_loader_cls_id').show();
          },
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            jQuery('.cart_loader_cls_id').hide();
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_clear_all: function(){
        var ajax = {
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      update_cart_form: function(form){
        var ajax = {
          type: "POST",
          url: "/cart/update.js",
          data: jQuery("#" + form).serialize(),
          dataType: "json",
          beforeSend: function(){
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      }
    }
  }

  jQuery(document).on('click', '.wc_product_cart_submit', function(){

    var this_click = $(this).data('click');
    var temp_variant_id = $(this).attr('data-variant_id');
    var temp_qty = 1;
    wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
    return false;
  });



  jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
    var this_click = $(this).data('click');
    var temp_form_id = jQuery(this).closest('form').attr('id');
    wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click);
    return false;
  });

  jQuery(document).ready(function(){
    ajaxCart.load();
  });	






  var slideArrow = '<svg class="icon icon-chevron-left" viewBox="0 0 8 18"><path d="M7.55.978A.705.705 0 007.413.01a.663.663 0 00-.945.142L.019 9.06l6.433 8.558a.664.664 0 00.947.127.704.704 0 00.121-.972L1.713 9.046z"></path></svg>';

  // ie: Engine.ui.misc();
  $(function() {
    "use strict";
    var Engine = {
      ui: {
        misc: function() {
          $(".theme-drawer-toggle,.cart-close,.cart-drawer-overlay").on('click', function() {
            $("body").toggleClass("CartOpen");
            $("body").removeClass("enabled-offcanvas");
            return false;
          });
          $(".search-toggle-button,button.search_close").on('click', function() {
            $("body").toggleClass("searchOpen");
             $("body").removeClass("enabled-offcanvas");
            return false;
          });
          $("#expand-drawer-toggle").on('click', function() {
            $("body").toggleClass("enabled-offcanvas");
             $("body").removeClass("searchOpen");
            $("body").removeClass("CartOpen");
            return false;
          });
          $(".theme-overlay").on('click', function() {
            $("body").removeClass("enabled-offcanvas");
            $("body").removeClass("searchOpen");            
            return false;
          });
			
          $(".menu-item .menu-item-icon").on('click', function() {            
            $(this).closest('.menu-item').find('.menu-item-dropdown:first').addClass('open-sub');
            return false;
          });
          $("button.menu-item-return-toggle").on('click', function() {            
            $(this).closest('.menu-item-dropdown').removeClass('open-sub');
            return false;
          });
          
          $("button.filter-toggle").on('click', function() {            
            $('.collection-sidebar').toggleClass('open');
            $('body').toggleClass('filter-open');
            return false;
          });
          $(".filter-overlay").on('click', function() {
            $(".collection-sidebar").removeClass("open");
            $("body").removeClass("filter-open");            
            return false;
          });
          
          

          $(".dropdown .dropdown-toggle").on('click', function() {
            $(this).parents(".dropdown").find(".dropdown-options").toggle();          
            $(this).toggleClass('in-active');
            return false;
          });        
          $(".dropdown .dropdown-options a").on('click', function() {
            var text = $(this).html();
            $(this).parents(".dropdown").find('.dropdown-toggle span').html(text);
            $(this).parents(".dropdown").find(".dropdown-options").hide();
          });       
          $(document).bind('click', function(e) {
            var $clicked = $(e.target);
            if (! $clicked.parents().hasClass("dropdown"))
              $(".dropdown .dropdown-options").hide();
            $(".dropdown .dropdown-toggle").removeClass('in-active');
          });


          $('.QuantityBox .plus').on('click', function() {            
            var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
            var currentVal = parseInt($qty.val(), 10);
            if (1 <= currentVal) {
              $(this).parents('.QuantityBox').find('li.minus-box').removeClass('disabled');
            }
            if (!isNaN(currentVal)) { $qty.val(currentVal + 1);}
          });
          $('.QuantityBox .minus').on('click', function() {
            var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
            var currentVal = parseInt($qty.val(), 10);
            if (currentVal <= 2) {
              $(this).parents('.QuantityBox').find('li.minus-box').addClass('disabled');
            }

            if (!isNaN(currentVal) && currentVal > 1) {$qty.val(currentVal - 1);}
          });
          
          $(document).on('mouseover', '.swatch_hover_tigger', function(){
            console.log(hover_img);
            var hover_img = $(this).find('span').data('image');
            console.log(hover_img);
            $(this).parents('.shop_item').find('.shop_image ').attr('srcset', hover_img);
          });
          
          if ($(window).width() <= 576) {		
            $('.footer-menu-toggle').on('click', function() {
              
              
              if ($(this).hasClass('in-active')) {
                $(this).parent('.footer-menu-part').find('ul.footer-menu-ul').slideUp();
                $(this).removeClass('in-active');
              }else{
              $(this).parent('.footer-menu-part').find('ul.footer-menu-ul').slideDown();
                $(this).addClass('in-active');
              }

              
            });
          }



        }, // end misc
        metisNavMenu: function() {

        },
        stickyHeader: function() {        

        },
      }, // end ui
      utils: {
        sliders: function() {
          //  Home Slider
          var slideshow_autorotate = $('ul.slideshow-wrapper').data('autorotate');
          var slideshow_speed = $('ul.slideshow-wrapper').data('speed');
          $('ul.slideshow-wrapper').slick({
            arrows: true,
            speed: 1000,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
            touchMove: true,
            slide: 'li',
            prevArrow: '<button type="button" class="slick-arrow slick-prev">'+slideArrow+'</button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next">'+slideArrow+'</button>',
            utoplay: slideshow_autorotate,
            autoplaySpeed: slideshow_speed
          });  
          


        },
      }, // end utils
    };
    Engine.ui.misc();
    Engine.ui.metisNavMenu();
    Engine.ui.stickyHeader();
    Engine.utils.sliders();
  });


  function find_soldout_variant(){
    $('.th_product_parent_cls').each(function(grid_index){
      var pair_grid_this = $(this);
      var color_selected = pair_grid_this.find('.color-wrap input:checked').val();
      pair_grid_this.find('.shop_select option').each(function(option_index){
        var option_this = $(this);
        var option_title = option_this.data('title');

        // console.log(option_title.indexOf(color_selected));


        if(option_title.indexOf(color_selected) != -1){
          option_title = option_title.replace(color_selected,'');
          option_title = option_title.replace(' / ','');


          if(option_this.data('available') == false){
            pair_grid_this.find('.shop_variants_div .shop_swatch_input[value="'+option_title+'"]').prop('disabled', true);
            pair_grid_this.find('.shop_variants_div .shop_swatch_label[data-value="'+option_title+'"]').addClass('wc_soldout');

          } else{
            pair_grid_this.find('.shop_variants_div .shop_swatch_input[value="'+option_title+'"]').prop('disabled', false);
            pair_grid_this.find('.shop_variants_div .shop_swatch_label[data-value="'+option_title+'"]').removeClass('wc_soldout');
          }
        }else{
          if(option_this.data('available') == false){
            pair_grid_this.find('.shop_variants_div .shop_swatch_input[value="'+option_title+'"]').prop('disabled', true);
            pair_grid_this.find('.shop_variants_div .shop_swatch_label[data-value="'+option_title+'"]').addClass('wc_soldout');
          } 
        }
      });
    });
  }

  $(document).on('change', '.shop_swatch_input', function(){

    var input_this = $(this);
    var this_parents = input_this.parents('.th_product_parent_cls');
    var th_selected_val = new Array();
    this_parents.find('.shop_variants_div').each(function(index){
      var input_selected_val = $(this).find('.shop_swatch_input:checked').val();
      var input_selected_size = $(this).find('.shop_swatch_input:checked').length;

      th_selected_val.push(input_selected_val);
      if(index === this_parents.find('.shop_variants_div').length - 1){
        var final_selected_val =  th_selected_val.join(" / ");
        input_this.parents('.th_product_parent_cls').find('.shop_select').prop('selected', false);
        input_this.parents('.th_product_parent_cls').find('.shop_select option[data-title="'+final_selected_val+'"]').prop('selected', true).trigger('change');
        console.log(input_selected_val);
      }
    });
    find_soldout_variant();
  });




  $(document).on('change', '.shop_select', function(){
    var th_selected_val = $(this).find('option:selected');
    /* 
    var th_vari_price = th_selected_val.data('price');
    var th_vari_compare_price = th_selected_val.data('compare-price');
    var th_vari_price_only = th_vari_price.replace('$', '');
    var th_vari_compare_price_only = th_vari_compare_price.replace('$', '');
    */
    var th_vari_available = th_selected_val.data('available');
    var th_vari_id = th_selected_val.val();
    $(this).parents('.th_product_parent_cls').find('button.wc_product_cart_submit').attr('data-variant_id',th_vari_id);

    /* 
    $(this).parents('.th_product_parent_cls').find('.product_price').text(th_vari_price);
    if(parseFloat(th_vari_compare_price_only) > parseFloat(th_vari_price_only)){
      $(this).parents('.th_product_parent_cls').find('.product_compare_price').text(th_vari_compare_price);
      $(this).parents('.th_product_parent_cls').find('.product_compare_price').show();
      $(this).parents('.th_product_parent_cls').find('.shop-price').addClass('sp_comp');
    } else{
      $(this).parents('.th_product_parent_cls').find('.product_compare_price').hide();
      $(this).parents('.th_product_parent_cls').find('.shop-price').removeClass('sp_comp');
    }
    */
    var add_to_cart_text = 'Add To Cart';
    var sold_out_text = 'Sold Out';
    if(th_vari_available == 'true' || th_vari_available){

      $(this).parents('.th_product_parent_cls').find('button.wc_product_cart_submit').prop('disabled', false).text(add_to_cart_text);
    } else{
      $(this).parents('.th_product_parent_cls').find('button.wc_product_cart_submit').prop('disabled', true).text(sold_out_text);
    }
    find_soldout_variant();
  });

  $(window).on("load", function(){
    $('.th_product_parent_cls').each(function(index){
      var swatch_pair_title = $(this).find('.color-wrap input:checked').val();
      $(this).find('.color-guide-swatch').text(swatch_pair_title);      
      find_soldout_variant();
    });
  });



  $(function() {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
      var links = this.el.find('.card-trigger');
      links.on('click', {
        el: this.el,
        multiple: this.multiple
      }, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
      $this = $(this),
        $next = $this.next();

      $next.slideToggle();
      $this.parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.card-content').not($next).slideUp().parent().removeClass('open');
      };
    }
    var accordion = new Accordion($('.accordion'), false);
  });

  $(document).on('click', function (event) {
    var $this = $(this);
    if (!$(event.target).closest('.accordion').length) {
      $this.parent().toggleClass('open');
    }
  });

  $(document).on("click", ".chat-now", function(e) {
    e.preventDefault(); 
    zE.hide();
    LC_API.open_chat_window();
    if(window.lc_agent_available && typeof LC_API !== 'undefined') {
      zE.hide();
      LC_API.open_chat_window();
      return false;
    }
  });

  $(document).on("click", ".email-now.open-widget", function(e) {  
    e.preventDefault();
    if(typeof LC_API !== 'undefined') {
      LC_API.hide_chat_window();
    }
    zE.activate({hideOnClose: true});
  });
  $(document).on('click','button[data-address-toggle]',function(e){
    var dataForm = $(this).data('address-toggle');
    $('div['+dataForm+']').slideToggle('hide');
  });
  $(document).on('click','.account_nav_btn', function(e) {
    $('.account-sidebar-links').slideToggle();
    $(this).toggleClass('active');
  });

  $(document).on('click','button.collapsible-trigger', function(e) {
    if($(this).parent('li').hasClass('in-active')){      
      $(this).parent('li').removeClass('in-active');
      $(this).parent('li').find('.filter-items-contain').slideUp(100);
    }else{
      $('ul.filter_catalog_list li.filter_items').removeClass('in-active');
      $('.filter-items-contain').slideUp(100);
      $(this).parent('li').addClass('in-active');
      $(this).parent('li').find('.filter-items-contain').slideDown(400);      
    }
     return false;
  });
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("filter-items-contain"))
      $('ul.filter_catalog_list li.filter_items ').removeClass('in-active');
    $('.filter-items-contain').slideUp(100);
  });
  $(document).on('click','.hide_filter_inner',function(){
    $(this).parents('.collection-sidebar').removeClass('open');
    $('body').removeClass('filter-open');
  });
  $(document).on('click','label.close.mobile_side',function(){
    $('body').removeClass('enabled-offcanvas');
  });
  
  $(document).ready(function(){
    $('.review-slider .review-desc p').matchHeight({property:'height'});
  })

  $(window).on('load', function(){
    setTimeout(function(){
      $('.home-product-wrap figure').matchHeight({property:'height'});
      $('.home-product-wrap h4').matchHeight({property:'height'});
      $('.home-product-wrap .home-product-price').matchHeight({property:'height'});
      $('.home-product-wrap .wc_product_cart_submit').matchHeight({property:'height'});
      $('.home-product-wrap .yotpo').matchHeight({property:'height'});
    }, 3000);
  });
  $(window).resize(function(){
    $('.home-product-wrap figure').matchHeight({property:'height'});
    $('.home-product-wrap h4').matchHeight({property:'height'});
    $('.home-product-wrap .home-product-price').matchHeight({property:'height'});
    $('.home-product-wrap .wc_product_cart_submit').matchHeight({property:'height'});
    $('.home-product-wrap .yotpo').matchHeight({property:'height'});
    $('.review-slider .review-desc p').matchHeight({property:'height'});
  });
  
  
